export default __webpack_public_path__ + "static/media/ic-faq.84eb13ce.svg";